var detectBrowser = require('./lib/detectBrowser');

module.exports = detectBrowser(navigator.userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/detect-browser/browser.js
// module id = 351
// module chunks = 0 1 2